import { Edit, Link2, Star } from 'lucide-react'

import AchievementCard from './components/achievement-card'
import ExperienceSection from './components/experience-section.tsx'
import ProfessionalismCard from './components/professionalism-card'
import ProficiencyCard from './components/proficiency-card'
import ProfileSidebar from './components/profile-sidebar'
import ProgrammingSkills from './components/programming-skills'
import ProjectsSection from './components/projects-section'

export default function ProfilePage() {
    return (
        <div className="flex h-screen">
            <div className="w-[372px] flex-shrink-0">
                <ProfileSidebar />
            </div>
            <div className="flex-1 overflow-y-auto">
                <div className="max-w-4xl">
                    <header className="flex items-center justify-between p-6 pb-4">
                        <h1 className="text-2xl font-bold">Showcase</h1>
                        <div className="flex gap-2">
                            <button className="p-2 rounded-full hover:bg-gray-100">
                                <Edit className="w-5 h-5 text-gray-500" />
                            </button>
                            <button className="p-2 rounded-full hover:bg-gray-100">
                                <Link2 className="w-5 h-5 text-gray-500" />
                            </button>
                        </div>
                    </header>

                    <section className="px-6 pb-6">
                        <div className="flex items-center gap-2 mb-4">
                            <div className="bg-yellow-100 p-1 rounded-full">
                                <Star className="w-5 h-5 text-yellow-400 fill-yellow-400" />
                            </div>
                            <h2 className="font-medium">Achievements</h2>
                        </div>

                        <div className="space-y-4">
                            <AchievementCard />
                        </div>
                    </section>

                    <section className="px-6 pb-6 grid grid-cols-1 md:grid-cols-2 gap-6">
                        <ProficiencyCard />
                        <ProfessionalismCard />
                    </section>

                    <ProgrammingSkills />

                    <ProjectsSection />

                    <ExperienceSection />
                </div>
            </div>
        </div>
    )
}
